<template>
  <b-modal
    ref="modal"
    size="xl"
    title="Parametrização de regras do item do checklist"
    hide-footer
    no-close-on-backdrop
    @hide="hide"
  >
    <b-container fluid>
      <b-row class="mt-1">
        <b-col
          cols="8"
        >
          <b-input
            v-model="itemRegra.descricao"
            class="input-md"
            placeholder="Descreva a pergunta"
          />
        </b-col>
        <b-col cols="4">
          <v-select
            v-model="opcaoSelecionada"
            :options="opcoes"
            :searchable="false"
            :placeholder="'Escolha o formato de resposta'"
            @input="opcaoAlterada"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-1">
          <b-input
            v-model="itemRegra.complementoRegra"
            placeholder="Complemente a pergunta do checklist, essa descrição é visível para a pessoa (Cliente final)"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="opcaoSelecionada !== null"
        class="mt-2"
      >
        <b-col cols="12">
          <hr
            class="mx-0 mt-0 mb-2"
            style="border-top: 0.15px solid rgb(0 0 0 / 15%) !important;"
          >
        </b-col>
      </b-row>
      <b-row v-if="opcaoSelecionada !== null">
        <b-col>
          <item-servico
            v-for="(itemServico, $index) in itensRegra"
            :key="itemServico.id > 0 ? itemServico.id : itemServico.code"
            :ref="`item${itemServico.id > 0 ? itemServico.id : itemServico.code}`"
            v-model="itensRegra[$index]"
            :tipo-regra="opcaoSelecionada.value"
            :id-item="itemServico.id > 0 ? itemServico.id.toString() : itemServico.code"
            :numero-opcao="$index"
            :state="itemServico.state"
            :tributacao-id="tributacaoSelecionadaId"
            :atividade-id="atividadeSelecionadaId"
            @remove="remove"
            @mudar-edicao="mudarEdicao"
            @add-regra="addOption"
          />
          <div
            v-if="opcaoSelecionada.value === 'listasuspensa' || opcaoSelecionada.value === 'caixaselecao'"
            class="add-item-regra"
          >
            <a
              class="text-primary opcao-hover"
              style="cursor:pointer;font-size:13.5px"
              @click.stop="addOption"
            ><span>Adicionar opção</span></a>
            <span v-if="!itensRegra.some(som => som.outros)"> ou</span>
            <a
              v-if="!itensRegra.some(som => som.outros)"
              class="text-primary opcao-hover"
              style="cursor:pointer;font-size:13.5px"
              @click.stop="addOptionOutros"
            ><span> Adicionar opção "Outros"</span></a>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="12">
          <hr
            class="mx-0 mt-0 mb-2"
            style="border-top: 0.15px solid rgb(0 0 0 / 15%) !important;"
          >
        </b-col>
      </b-row>
      <b-row
        align-h="end"
      >
        <b-col cols="auto">
          <div
            class="box"
          >
            <b-btn
              variant="none"
              size="sm"
              class="btn-outline-danger btn-none"
              @click="limpaCampos"
            >
              <feather-icon icon="Trash2Icon" />
            </b-btn>
            <div class="mr-50 ml-2 linha-vertical-regra">
              <span style="margin-left: 1.2rem;">Obrigatória</span>
            </div>
            <div>
              <b-form-checkbox
                v-model="obrigatorio"
                class="custom-control-primary"
                name="check-button"
                switch
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row />
    </b-container>
  </b-modal>
</template>

<style lang="scss">
.box {
  display: flex;
  align-items: baseline;
}

.linha-vertical-regra {
  height: 25px;/*Altura da linha*/
  border-left: 1px solid rgb(0 0 0 / 15%);/* Adiciona borda direita na div como ser fosse uma linha.*/
}

.add-item-regra {
  margin: 1rem 1rem 0 0.5rem;
}

.opcao-hover.text-primary:hover {
  color: #1b874a !important;
}
</style>

<script>
import vSelect from 'vue-select'

export default {
  name: 'RegraItemChecklist',
  components: {
    vSelect,
    ItemServico: () => import('@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/components/cadastro-regra/itens-servico/ItemServico.vue'),
  },
  props: {
    itemChecklistRegra: {
      type: Object,
      required: true,
    },
    tributacaoId: {
      type: Number,
      default: 0,
    },
    atividadeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      opcoes: [
        { label: 'Texto livre', value: 'textolivre' },
        { label: 'Numérico', value: 'numerico' },
        { label: 'Lista suspensa', value: 'listasuspensa' },
        { label: 'Caixa de seleção', value: 'caixaselecao' },
      ],
      opcaoSelecionada: null,
      itemRegra: null,
      itensRegra: [],
      obrigatorio: true,
      edicaoAtualRegra: {},
      tributacaoSelecionadaId: 0,
      atividadeSelecionadaId: 0,
    }
  },
  watch: {
    itemChecklistRegra(value, oldValue) {
      if (value !== oldValue) {
        this.itemRegra = value
      }
    },
    tributacaoId(value, oldValue) {
      if (value !== oldValue) {
        this.tributacaoSelecionadaId = value
      }
    },
    atividadeId(value, oldValue) {
      if (value !== oldValue) {
        this.atividadeSelecionadaId = value
      }
    },
  },
  created() {
    this.itemRegra = this.itemChecklistRegra
    if (this.itemRegra.tipoRegra) {
      this.opcaoSelecionada = this.opcoes.find(fin => fin.value === this.itemRegra.tipoRegra)
    }

    this.tributacaoSelecionadaId = this.tributacaoId
    this.atividadeSelecionadaId = this.atividadeId

    if (this.itemRegra.servicosItems) {
      this.itensRegra = this.itemRegra.servicosItems
    } else {
      this.addOption()
    }
  },
  methods: {
    show() {
      this.$refs.modal.show()
      if (this.itemRegra) {
        if (this.itemRegra.obrigatorioRegra === undefined) {
          this.obrigatorio = true
        } else if (this.itemRegra.obrigatorioRegra !== undefined) {
          this.obrigatorio = this.itemRegra.obrigatorioRegra
        }
      }
    },
    addOption() {
      if (!this.hasError()) {
        const itemServico = {
          code: Date.now().toString(36) + Math.random().toString(36).substring(2),
          id: 0,
          state: 'criacao',
          outros: false,
        }

        if (this.itensRegra && this.itensRegra.some(som => som.outros)) {
          const index = this.itensRegra.findIndex(fin => fin.outros)
          if (index && index >= 0) {
            const itemRemovido = this.itensRegra.splice(index, 1)
            this.itensRegra.push(itemServico)
            this.itensRegra.push(itemRemovido[0])
          }
        } else {
          this.itensRegra.push(itemServico)
        }
        this.mudarEdicao(itemServico)
      }
    },
    addOptionOutros() {
      if (!this.hasError()) {
        const itemServico = {
          code: Date.now().toString(36) + Math.random().toString(36).substring(2),
          id: 0,
          state: 'criacao',
          outros: true,
          descricao: 'Outros',
        }

        this.itensRegra.push(itemServico)
        this.mudarEdicao(itemServico)
      }
    },
    opcaoAlterada() {
      this.itensRegra = []
      this.addOption()
    },
    hasError() {
      if (this.itensRegra.length > 0) {
        if ((this.edicaoAtualRegra.id > 0 || this.edicaoAtualRegra.id === 0) && !this.edicaoAtualRegra.descricao) {
          this.$refs[`item${this.edicaoAtualRegra.id > 0 ? this.edicaoAtualRegra.id : this.edicaoAtualRegra.code}`][0].descricaoInvalida = 'Insira uma descricao'
          return true
        }
        if (this.edicaoAtualRegra.id > 0 || this.edicaoAtualRegra.id === 0) {
          this.$refs[`item${this.edicaoAtualRegra.id > 0 ? this.edicaoAtualRegra.id : this.edicaoAtualRegra.code}`][0].descricaoInvalida = null
        }
      }
      return false
    },
    hide() {
      if (this.opcaoSelecionada) {
        if (this.opcaoSelecionada.value === 'listasuspensa' || this.opcaoSelecionada.value === 'caixaselecao') {
          const regraItem = this.itensRegra.find(find => (!find.descricao || find.descricao === '') && !find.servico)
          if (regraItem) {
            this.remove(regraItem)
          }
        }
        this.itemChecklistRegra.servicosItems = this.itensRegra
        this.itemChecklistRegra.tipoRegra = this.opcaoSelecionada.value
        this.itemChecklistRegra.obrigatorioRegra = this.obrigatorio
        const countServico = this.itensRegra.filter(fil => fil.servico && fil.servico.id > 0).length
        this.$emit('hide-modal', countServico)
      } else {
        this.$emit('hide-modal')
      }
    },
    remove(value) {
      this.itensRegra = this.itensRegra.filter(fil => (fil.code && fil.code !== value.code) || (fil.id > 0 && fil.id !== value.id))
      const obj = []
      this.mudarEdicao(obj)
    },
    limpaCampos() {
      this.itensRegra = []
      this.opcaoSelecionada = null
      this.itemRegra.complementoRegra = null
      this.itemChecklistRegra.tipoRegra = null
      this.obrigatorio = true
    },
    mudarEdicao(obj) {
      if (this.edicaoAtualRegra) {
        const ref = this.$refs[`item${this.edicaoAtualRegra.id > 0 ? this.edicaoAtualRegra.id : this.edicaoAtualRegra.code}`]
        if (ref && ref.length > 0) {
          ref[0].atualizarEstado('visualizacao')
        }
      }
      this.edicaoAtualRegra = obj
    },
  },
}
</script>
